import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import { GenericInput } from '../../../../../components/Inputs'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { UprightStyle } from '../../../../../types'
import { templateStyles } from './templateStyles'

const styles: UprightStyle = {
  textAreaContainer: { height: '100%' }
}

export const Form = ({ input, onFormPreviewChange, index }) => {
  const props = input.get('props')
  return (
    <div style={styles.textAreaContainer}>
      <InputLabel
        title={props.get('label')}
        required={props.get('required') && isEmpty(props.get('value'))}
        style={styles.textAreaContainer}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.get('requiredLabelIconName')}
      >
        <textarea
          style={{ width: '100%', height: 'calc(100% - 25px)' }}
          className="bp3-input"
          value={props.get('value')}
          placeholder={props.get('placeholder')}
          onChange={e => onFormPreviewChange(index, e.target.value)}
        />
      </InputLabel>
      {props.get('helpText') && (
        <Help>
          <div>{props.get('helpText')}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.get('props')
  return (
    <div>
      <GenericInput
        title="Placeholder"
        value={inputProps.get('placeholder')}
        onChange={v => onChange('placeholder', v)}
      />
    </div>
  )
}
